module.exports = __webpack_public_path__ + "img/sexm.24b6110b.png";